export const requestUrl = {
  // url: 'https://wxapi.yixiang.co/api',
   //url: 'http://localhost:11001/cbec/api/v1',
   url: 'https://shop.chengmeimedicine.com/cbec/api/v1',
  // url: 'http://122.9.152.120:39003/cbec/api/v1',
  // url: '/proxy',
  timeout: 30000
}



// WEBPACK FOOTER //
// ./src/utils/requestConfig.js